// Titles for the topbar breadcrumb ("WORKSPACE / <TITLE>"). Matched by longest
// prefix, so nested routes (/admin/borrow-batches/12/approval) fall back to
// their section instead of needing an entry each.
const PAGE_TITLES = [
  ["/", "Dashboard"],
  ["/dashboard", "Dashboard"],
  ["/items", "Barang"],
  ["/categories", "Kategori"],
  ["/locations", "Lokasi"],
  ["/transactions", "Transaksi"],
  ["/my-transactions", "Transaksi Saya"],
  ["/barang-di-luar", "Barang di Luar"],
  ["/damaged", "Barang Rusak"],
  ["/temporary-items", "Barang Terpakai"],
  ["/panel-assemblies", "Perakitan Panel"],
  ["/admin/panel-assemblies", "Approval Rakitan"],
  ["/panel-templates", "Template Panel"],
  ["/order-panel", "Order Panel"],
  ["/loan-transactions", "Peminjaman"],
  ["/my-loan-requests", "Pengajuan Pinjam"],
  ["/active-borrows", "Peminjaman Aktif"],
  ["/admin/borrow-batches", "Peminjaman"],
  ["/borrow-batches", "Peminjaman"],
  ["/borrow", "Pinjam Barang"],
  ["/borrow-requests", "Peminjaman"],
  ["/cart", "Keranjang"],
  ["/users", "Users"],
  ["/roles", "Role"],
  ["/audit", "Audit Log"],
  ["/debug-log", "Debug Log"],
  ["/settings", "Settings"],
  ["/profile", "Profil"],
  ["/administrasi/sekretaris/form-pengajuan", "Form Pengajuan"],
  ["/administrasi/sekretaris/surat-masuk", "Surat Masuk"],
  ["/administrasi/sekretaris/surat-keluar", "Surat Keluar"],
  ["/administrasi/sekretaris/arsip", "Arsip Dokumen"],
  ["/administrasi/bendahara/anggaran", "Anggaran"],
  ["/administrasi/bendahara/pengajuan-dana", "Pengajuan Dana"],
  ["/administrasi/bendahara/kas-masuk", "Kas Masuk"],
  ["/administrasi/bendahara/realisasi-nota", "Realisasi Nota"],
  ["/administrasi/bendahara/kas-keluar", "Kas Keluar"],
  ["/administrasi/bendahara/lpj", "LPJ"],
  ["/administrasi/folder-config", "Event & Folder"],
  ["/administrasi/template-manager", "Template Surat"],
];

export function pageTitleFor(pathname) {
  let best = null;
  for (const [prefix, title] of PAGE_TITLES) {
    const hit =
      prefix === "/"
        ? pathname === "/"
        : pathname === prefix || pathname.startsWith(`${prefix}/`);
    if (hit && (!best || prefix.length > best[0].length)) best = [prefix, title];
  }
  if (best) return best[1];

  // Unknown route: prettify the last path segment.
  const last = pathname.split("/").filter(Boolean).pop() || "Dashboard";
  return last.replace(/[-_]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
